import { useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from '~/helpers/hotKeys';
import { useIsModalOpen } from '~/hooks/useIsModalOpen';

type Props = {
    handlePageChangePrevious: () => void;
    handlePageChangeNext: () => void;
};

export default function usePageShortcuts({ handlePageChangePrevious, handlePageChangeNext }: Props) {
    const isModalOpen = useIsModalOpen();

    const handlePageChange = (event) => {
        if (isInteractiveElement(event) || isCtrlKey(event) || event.shiftKey || isModalOpen) {
            return;
        }

        // Select next page
        if (['ArrowUp', 'PageUp', 'PgUp'].includes(event.code)) {
            event.preventDefault();

            if (handlePageChangePrevious) {
                handlePageChangePrevious();
            }
        }

        // Select previous page
        if (['ArrowDown', 'PageDown', 'PgDn'].includes(event.code)) {
            event.preventDefault();

            if (handlePageChangeNext) {
                handlePageChangeNext();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handlePageChange);

        return () => {
            document.removeEventListener('keydown', handlePageChange);
        };
    }, [handlePageChange, isModalOpen]);
}
